/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

// library imports
import { Component } from 'react';

/**
 * redirected to this page when link is not found
 * 
 * @returns html to render not found page
**/

export class NotFound extends Component {
    render () {
        return (
            <h1 style={{textAlign:'center',position:'absolute',left:'50%',top:'50%',transform:'translate(-50%, -50%)',padding:'10px'}}>No Data Found</h1>
        );
    }
}